const ansi = {
  black: (t:string) => `\x1b[30m${t}\x1b[0m`,
  red: (t:string) => `\x1b[31m${t}\x1b[0m`,
  green: (t:string) => `\x1b[32m${t}\x1b[0m`,
  yellow: (t:string) => `\x1b[33m${t}\x1b[0m`,
  blue: (t:string) => `\x1b[34m${t}\x1b[0m`,
  magenta: (t:string) => `\x1b[35m${t}\x1b[0m`,
  cyan: (t:string) => `\x1b[36m${t}\x1b[0m`,
  white: (t:string) => `\x1b[37m${t}\x1b[0m`,
  brightBlack: (t:string) => `\x1b[90m${t}\x1b[0m`,
  brightRed: (t:string) => `\x1b[91m${t}\x1b[0m`,
  brightGreen: (t:string) => `\x1b[92m${t}\x1b[0m`,
  brightYellow: (t:string) => `\x1b[93m${t}\x1b[0m`,
  brightBlue: (t:string) => `\x1b[94m${t}\x1b[0m`,
  brightMagenta: (t:string) => `\x1b[95m${t}\x1b[0m`,
  brightCyan: (t:string) => `\x1b[96m${t}\x1b[0m`,
  brightWhite: (t:string) => `\x1b[97m${t}\x1b[0m`,
  bgBlack: (t:string) => `\x1b[40m${t}\x1b[0m`,
  bgRed: (t:string) => `\x1b[41m${t}\x1b[0m`,
  bgGreen: (t:string) => `\x1b[42m${t}\x1b[0m`,
  bgYellow: (t:string) => `\x1b[43m${t}\x1b[0m`,
  bgBlue: (t:string) => `\x1b[44m${t}\x1b[0m`,
  bgMagenta: (t:string) => `\x1b[45m${t}\x1b[0m`,
  bgCyan: (t:string) => `\x1b[46m${t}\x1b[0m`,
  bgWhite: (t:string) => `\x1b[47m${t}\x1b[0m`,
  bgBrightBlack: (t:string) => `\x1b[100m${t}\x1b[0m`,
  bgBrightRed: (t:string) => `\x1b[101m${t}\x1b[0m`,
  bgBrightGreen: (t:string) => `\x1b[102m${t}\x1b[0m`,
  bgBrightYellow: (t:string) => `\x1b[103m${t}\x1b[0m`,
  bgBrightBlue: (t:string) => `\x1b[104m${t}\x1b[0m`,
  bgBrightMagenta: (t:string) => `\x1b[105m${t}\x1b[0m`,
  bgBrightCyan: (t:string) => `\x1b[106m${t}\x1b[0m`,
  bgBrightWhite: (t:string) => `\x1b[107m${t}\x1b[0m`,
};

export default ansi;